import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Typography from 'carbon-react/lib/components/typography';

import { Integration } from '@futrli-sdk/app-store';
import { TechnicalIssuesCarbon } from '@futrli/shared-services';

import * as styles from './demo-organisations.scss';

interface Props {
  error?: boolean;
  activeIntegrationId?: string;
  handleConnectClick: (integration: Integration) => Promise<void>;
  demoIntegrations: Integration[];
}

export const DemoOrganisations = ({
  activeIntegrationId,
  handleConnectClick,
  demoIntegrations,
  error
}: Props) => {
  const isDemoOrgActive = !!demoIntegrations.find(d => d.id === activeIntegrationId);
  const showError = isDemoOrgActive && error;

  return (
    <>
      <Typography
        my="30px"
        className={classNames({
          [styles.disabledContainer]: typeof activeIntegrationId === 'string'
        })}
      >
        <FormattedMessage
          id="onboarding.click_to_connect_demo_companies"
          defaultMessage="Click to connect <b1>Demo Company (UK)</b1> or <b2>Demo Company (AU)</b2>. Demo organisations will not affect the licences in your subscription."
          values={{
            b1: chunks => (
              <span
                className={classNames(styles.demoCompanyName, {
                  [styles.disabledDemoText]: typeof activeIntegrationId === 'string'
                })}
                onClick={() => handleConnectClick(demoIntegrations.find(i => i.slug === 'demo-eu')!)}
              >
                {chunks}
              </span>
            ),
            b2: chunks => (
              <span
                className={classNames(styles.demoCompanyName, {
                  [styles.disabledDemoText]: typeof activeIntegrationId === 'string'
                })}
                onClick={() => handleConnectClick(demoIntegrations.find(i => i.slug === 'demo-au')!)}
              >
                {chunks}
              </span>
            )
          }}
        />
      </Typography>
      {showError && (
        <div className={styles.errorMessageWrapper}>
          <TechnicalIssuesCarbon />
        </div>
      )}
    </>
  );
};
